export const reportMappings = [
  {
	"label": "UPC / Barcode",
	"value": "upc",
	"required": false,
	"requiredLabel": true,
	"partnerKey": "Expected Barcode Column",
	"pattern": /^\d{8,14}$/,   // digits only, typical barcode length range
	"numeric": false            // stored/treated as string, not summed/compared as a number
  },
  {
	"label": "Catalog Number",
	"value": "cat_no",
	"required": false,
	"requiredLabel": true,
	"partnerKey": "Expected SKU Column",
	"pattern": /^[A-Za-z0-9][A-Za-z0-9\-\/.\s]*$/,
	"numeric": false
  },
  {
	"label": "Sales Figure",
	"value": "total_sales",
	"required": false,
	"requiredLabel": true,
	"partnerKey": "Sales Column",
	"pattern": /^-?\d+(\.\d+)?$/,
	"numeric": true
  },
  {
	"label": "Stock Figure",
	"value": "stock",
	"required": false,
	"requiredLabel": true,
	"partnerKey": "Expected Qty-on-hand Column",
	"pattern": /^-?\d+(\.\d+)?$/,
	"numeric": true
  },
  {
	"label": "7 Days Sales (optional)",
	"value": "seven_day_sales",
	"required": false,
	"requiredLabel": false,
	"partnerKey": "7 Day Sales Column",
	"pattern": /^-?\d+(\.\d+)?$/,
	"numeric": true
  }
]